
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/market-insights",
      function () {
        return require("private-next-pages/market-insights.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/market-insights"])
      });
    }
  